import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable, { MTableAction } from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { checkIconSelect, getCatIcons } from '../../../configs/helpers/utility';
import { useSnackbar } from 'notistack';
import { Input } from '../../../assets/styled/Element';
import SelectIconsList from '../../../components/Select/SelectIconsList';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { useHistory } from 'react-router-dom';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { faFileEdit, faTrashAlt } from '@fortawesome/pro-duotone-svg-icons';

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function CatagoryManagement(props) {
   const history = useHistory();
   const addActionRef = useRef();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/reward/category/GetList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };

   const refreshData = () => {
      setData([]);
      getData();
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการประเภทของรางวัล</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => addActionRef.current.click()}
               >
                  เพิ่มประเภทของรางวัล
               </Button>
            </Box>
         </Box>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'nameTh',
                  title: 'ชื่อภาษาไทย',
                  editComponent: (props) => (
                     <Input
                        type='text'
                        value={props.value}
                        onChange={(e) => props.onChange(e.target.value)}
                        placeholder={'ชื่อภาษาไทย'}
                     />
                  ),
               },
               {
                  field: 'nameEn',
                  title: 'ชื่อภาษาอังกฤษ',
                  editComponent: (props) => (
                     <Input
                        type='text'
                        value={props.value}
                        onChange={(e) => props.onChange(e.target.value)}
                        placeholder={'ชื่อภาษาอังกฤษ'}
                     />
                  ),
               },
               {
                  field: 'icons',
                  title: 'ไอคอน/รูปภาพ',
                  sorting: false,
                  export: false,
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  editComponent: (props) => {
                     return (
                        <SelectIconsList
                           defaultValue={
                              props.rowData &&
                              checkIconSelect(props.rowData.iconId)
                           }
                           onChange={(e) => props.onChange(e)}
                        />
                     );
                  },
                  render: (rowData) => getCatIcons(rowData.iconId),
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               padding: 'dense',
               actionsColumnIndex: -1,
               addRowPosition: 'first',
               actionsCellStyle: {
                  color: '#ccc',
               },
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  deleteTooltip: 'ลบ',
                  editTooltip: 'แก้ไข',
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            components={{
               Action: (props) => {
                  //If isn't the add action
                  if (
                     typeof props.action === typeof Function ||
                     props.action.tooltip !== 'Add'
                  ) {
                     return <MTableAction {...props} />;
                  } else {
                     return (
                        <div
                           ref={addActionRef}
                           onClick={props.action.onClick}
                        />
                     );
                  }
               },
            }}
            icons={{
               ...tableIcons,
               Delete: React.forwardRef((props, ref) => (
                  <FontAwesomeIcon
                     ref={ref}
                     {...props}
                     color='#ed1c24'
                     icon={faTrashAlt}
                  />
               )),
               Edit: React.forwardRef((props, ref) => (
                  <FontAwesomeIcon
                     ref={ref}
                     {...props}
                     color='#00a2e8'
                     icon={faFileEdit}
                  />
               )),
               Check: React.forwardRef((props, ref) => (
                  <Button
                     style={{ padding: 2, minWidth: 50 }}
                     variant='contained'
                     color='primary'
                     size={'small'}
                     ref={ref}
                     {...props}
                  >
                     ยืนยัน
                  </Button>
               )),
               Clear: React.forwardRef((props, ref) => (
                  <Button
                     style={{ padding: 2, minWidth: 50 }}
                     variant='contained'
                     size={'small'}
                     ref={ref}
                     {...props}
                  >
                     ยกเลิก
                  </Button>
               )),
            }}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
            ]}
            editable={{
               onRowAdd: (newData) => {
                  return new Promise((resolve, reject) => {
                     const IconId = newData.icons.value
                        ? newData.icons.value
                        : 0;
                     const fromData = new FormData();
                     fromData.append(
                        'NameTh',
                        newData.nameTh ? newData.nameTh : '',
                     );
                     fromData.append(
                        'NameEn',
                        newData.nameEn ? newData.nameEn : '',
                     );
                     fromData.append('IconId', IconId);
                     Axios.post(
                        '/GSB/dashboard/reward/category/Create',
                        fromData,
                     )
                        .then((resp) => {
                           enqueueSnackbar('สร้างรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
               onRowUpdate: (newData, oldData) => {
                  return new Promise((resolve, reject) => {
                     const IconId = newData.icons.value
                        ? newData.icons.value
                        : null;
                     const fromData = new FormData();
                     fromData.append(
                        'NameTh',
                        newData.nameTh ? newData.nameTh : null,
                     );
                     fromData.append(
                        'NameEn',
                        newData.nameEn ? newData.nameEn : null,
                     );
                     fromData.append('IconId', IconId);
                     fromData.append('Reference', oldData.reference);
                     Axios.post('/GSB/dashboard/reward/category/Edit', fromData)
                        .then((resp) => {
                           enqueueSnackbar('แก้ไขรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
               onRowDelete: (oldData) => {
                  return new Promise((resolve, reject) => {
                     Axios.delete(
                        `/GSB/dashboard/reward/category/Delete?rewardRef=${oldData.reference}`,
                     )
                        .then((resp) => {
                           enqueueSnackbar('ลบรายการสำเร็จ!!', {
                              variant: 'success',
                           });
                           resolve(refreshData());
                        })
                        .catch((e) => {
                           LogToBackend(e);
                           reject(e);
                           if (e.response) {
                              const response = e.response.data;
                              enqueueSnackbar(response.errorAppMessageTh, {
                                 variant: 'error',
                              });
                           } else console.error('site error');
                        });
                  });
               },
            }}
         />
      </Paper>
   );
}

export default CatagoryManagement;
